import { FormikProps } from 'formik';

export const getFieldLabel = (name: string, isRequired: boolean) => {
  return isRequired ? `${name} *` : name;
};

export const clearFormError = (formik: FormikProps<any>, fieldName: string) => {
  if (!formik.getFieldMeta(fieldName).value) return;

  setTimeout(() => {
    formik.setFieldValue(fieldName, '');
  }, 0);
};
